import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import { useMaximize } from '@src/mobile/hooks/app';
import { setAppQuery } from '@src/mobile/utils/url';
import { getAwardList } from '../services';
import { Store } from '../store';

const Wrap = ({ children, content }) => {
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { shareTitle, shareDesc, shareThumbnail } = states;

    // 全屏且获取状态栏高度
    const statusBarHeight = useMaximize();

    useEffect(
        () => {
            // 将状态栏高度放到store中
            changeStates({ statusBarHeight });
        },
        [statusBarHeight],
    );

    useEffect(() => {
        // 请求接口
        getAwardList().then(res => {
            if (res.code === 0 && res.data) {
                const { data } = res.data;

                if (data && Array.isArray(data) && data.length) {
                    changeStates({ list: data });
                }
            }
        });
    }, []);

    useEffect(() => {
        // 将碎片数据放入store中
        const { awards } = content;
        const { thumbnail, title, desc } = awards;

        changeStates({ shareTitle: title, shareDesc: desc, shareThumbnail: thumbnail });
    }, []);

    useEffect(() => {
        pageStatistics({ behavior: 'page', id: 'bjda_awards', ref: 'dongao', type: 'other' });
    }, []);

    return (
        <>
            <div>{children}</div>
            <QQShare
                content={{
                    url: setAppQuery(`${window.location.origin}${window.location.pathname}`),
                    title: shareTitle,
                    img: shareThumbnail,
                    desc: shareDesc,
                    cb: () => {
                        console.log('分享成功');
                    },
                }}
            />
        </>
    );
};

Wrap.propTypes = {
    children: PropTypes.any,
    content: PropTypes.object,
};

export default errorBoundary(Wrap);
